import { HTTP_REFETCH_INTERVAL } from '@aibees/shared/http';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint } from '@aibees/shared/workspace';
import { BrowseInvoiceRequest, BrowseInvoiceResponse } from './types';

export function useBrowseInvoiceApi(params: BrowseInvoiceRequest) {
  const endpoint = useCustomerEndpoint('invoice');

  return useBaseQuery<BrowseInvoiceRequest, BrowseInvoiceResponse>(
    [useBrowseInvoiceApi.name, params],
    {
      url: endpoint,
      params,
    },
    {
      refetchInterval: HTTP_REFETCH_INTERVAL,
    }
  );
}
